import React, { useEffect, useState } from 'react'
import timeZones from '../data/us_state_county_time_zones.json'
import SelectWrapper from './select_wrapper'

interface USTimeZoneSelectProps {
    state: string
    county: string
    label: string
    path: string
    required?: boolean
}

interface CountyZone {
    County: string
    'Climate Zone': string
    'warm-humid?': string
}
interface TimeZoneData {
    [state: string]: CountyZone[]
}

const USTimeZoneSelectWrapper: React.FC<USTimeZoneSelectProps> = ({
    state,
    county,
    label,
    path,
    required,
}) => {
    const [climateZone, setClimateZone] = useState<string>('')

    useEffect(() => {
        if (state && county && (timeZones as TimeZoneData)[state]) {
            const stateData = (timeZones as TimeZoneData)[state]
            const countyObj = stateData.find(item => item?.County === county)
            if (countyObj) {
                const zone = countyObj['Climate Zone']
                const isWarmHumid = countyObj['warm-humid?'] === 'warm-humid'
                setClimateZone(isWarmHumid ? `${zone} (warm-humid)` : zone)
            } else {
                setClimateZone('')
            }
        } else {
            setClimateZone('')
        }
    }, [state, county])

    return (
        <SelectWrapper
            path={path}
            label={label}
            options={climateZone ? [climateZone] : ['No climate zone found']}
            required={required}
        />
    )
}

export default USTimeZoneSelectWrapper
